var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPasoInspeccion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4a8 8 0 100 16 8 8 0 000-16zm3.468 6.648a.726.726 0 10-1.117-.931l-3.128 3.752-1.618-1.619a.727.727 0 00-1.028 1.028l2.181 2.182a.727.727 0 001.073-.049l3.637-4.363z",
    fill: "#09C7A6"
  })));
}
export default SvgIconPasoInspeccion;